import * as actionTypes from './actions';
import config from '../config/config';

export const initialState = {
  isOpen: '', //for active default menu
  locale: config.i18n,
  navType: config.theme,
};

const customizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      return {
        ...state,
        isOpen: action.isOpen,
      };
    case actionTypes.MENU_TYPE:
      return {
        ...state,
        navType: action.navType,
      };
    case actionTypes.THEME_LOCALE:
      return {
        ...state,
        locale: action.locale,
      };
    default:
      return state;
  }
};

export default customizationReducer;
